// extracted by mini-css-extract-plugin
module.exports = {"container":"Block_container__2BgGD","isSelected":"Block_isSelected__2xidT"};